interface FilterBarProps {
  timeRange: string;
  onTimeRange: (value: string) => void;
  sort: string;
  onSort: (value: string) => void;
  tags: string[];
  selectedTags: string[];
  onToggleTag: (tag: string) => void;
  onReset: () => void;
}

const timeOptions = [
  { key: '7d', label: '最近 7 天' },
  { key: '30d', label: '最近 30 天' },
  { key: 'all', label: '全部时间' },
];

const sortOptions = [
  { key: 'latest', label: '最新' },
  { key: 'hot', label: '最热' },
];

function Segmented({
  options,
  value,
  onChange,
}: {
  options: { key: string; label: string }[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="inline-flex items-center gap-1 rounded-full bg-background-100 p-1">
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          onClick={() => onChange(option.key)}
          className={`px-3.5 py-1.5 text-sm rounded-full whitespace-nowrap transition-colors ${
            value === option.key
              ? 'bg-background-50 text-primary-700 font-medium'
              : 'text-foreground-500 hover:text-foreground-800'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default function FilterBar({
  timeRange,
  onTimeRange,
  sort,
  onSort,
  tags,
  selectedTags,
  onToggleTag,
  onReset,
}: FilterBarProps) {
  const hasActive = timeRange !== 'all' || sort !== 'latest' || selectedTags.length > 0;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex items-center gap-3">
            <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">发布时间</span>
            <Segmented options={timeOptions} value={timeRange} onChange={onTimeRange} />
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs font-medium text-foreground-400 whitespace-nowrap">排序</span>
            <Segmented options={sortOptions} value={sort} onChange={onSort} />
          </div>
        </div>
        {hasActive ? (
          <button
            type="button"
            onClick={onReset}
            className="self-start md:self-auto flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-200 px-3 py-1.5 text-sm text-foreground-500 hover:text-primary-700 hover:border-primary-300 transition-colors"
          >
            <i className="ri-refresh-line"></i>
            重置筛选
          </button>
        ) : null}
      </div>

      {tags.length > 0 ? (
        <div className="mt-4 pt-4 border-t border-background-200 flex flex-wrap items-center gap-2">
          <span className="text-xs font-medium text-foreground-400 mr-1">标签</span>
          {tags.map((tag) => {
            const active = selectedTags.includes(tag);
            return (
              <button
                key={tag}
                type="button"
                onClick={() => onToggleTag(tag)}
                className={`rounded-full px-3 py-1 text-xs whitespace-nowrap transition-colors ${
                  active
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-secondary-50 text-secondary-700 border border-secondary-200 hover:bg-secondary-100'
                }`}
              >
                {tag}
              </button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}